// extracted by mini-css-extract-plugin
module.exports = {"budgetInput":"KxxztiHaz0xBB1t9hkdg"};